import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { BreadcrumbComponent } from '@app/lib/components/breadcrumb/breadcrumb.component';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { BaseHttpService } from '@app/lib/services/base-http.service';
import { AppConfiguration } from '@app/lib/services/app-config.service';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { DialogService } from '@app/lib/services/dialog.service';
import { ConfirmationDialogComponent } from '@app/confirmation-dialog/confirmation-dialog.component';
import { ResetPasswordScreenService } from '../services/reset-password-screen.service';
import { IResponse } from '@app/lib/models/response.model';
import { ResetPassword } from '../models/reset-password.model';

@Component({
    selector: 'app-force-logoff',
    standalone: true,
    imports: [
        CommonModule,
        ReactiveFormsModule,
        HttpClientModule,
        MatTableModule,
        MatButtonModule,
        MatIconModule,
        MatInputModule,
        MatCheckboxModule,
        BreadcrumbComponent,
        MatProgressBarModule,
        MatDialogModule
    ],
    templateUrl: './force-logoff.component.html',
    styleUrl: './force-logoff.component.scss'
})
export class ForceLogoff implements OnInit {
    pageTitle = 'Force Log Off';
    breadcrumbs = [
        { label: 'Admin' },
        { label: 'Force Lof Off' }
    ];
    
    searchForm!: FormGroup;
 
    isLoading = false;
 

    constructor(
        private fb: FormBuilder,
        private dialog: MatDialog,
        private dialogService: DialogService,
        private service:ResetPasswordScreenService
    ) {
       
    }

    ngOnInit(): void {
        this.initSearchForm();
    }

    private showDialog(title: string, message: string): void {
        this.dialogService.openDialog1({
            data: {
                title: title,
                message: message,
                icon: title.toLowerCase().includes('error') ? 'error' : 'check_small'
            },
            disableClose: true,
            hasBackdrop: true,
            backdropClass: 'dialog-backdrop',
        });
    }

    initSearchForm(): void {
        this.searchForm = this.fb.group({
            userName: ['', [Validators.required, this.noSpecialCharsValidator]]
        });
        }

    private noSpecialCharsValidator(control: any) {
        if (!control.value) {
            return null;
        }
        const hasSpecialChars = /[^a-zA-Z0-9 ]/.test(control.value);
        return hasSpecialChars ? { 'specialChars': true } : null;
    }
     handleSearch() {
        if (this.searchForm.invalid) return;

        const queryParams: any = {
          forceLogoffUserName:this.searchForm.value.userName
        }
      
        this.service.forceLogoff(queryParams)
          .subscribe({
            next: (res: IResponse<any>) => {
                if(res.success){
                this.showDialog('Success',res.success)}
                else {
                    this.showDialog('Info',res.failure||res.success)
                }

              },
                error: (err: any) => {
                console.error('Search Failed', err);
                this.isLoading = false;
            }
          });
      }


    handleFormReset(): void {
        this.searchForm.reset();
      
    }

}
